import React, {useEffect, useState} from 'react';
import {Menu} from 'antd';
import {Link, matchPath, useLocation} from 'react-router-dom';
import _ from 'lodash';

import {MenuConfig} from './AppRoutes';
import {useAppStore} from './context';
import {useAuthStore} from '@/context/auth';

export default function AppSiderMenu() {
    const [{isMgr, extAttr}] = useAppStore();
    const [authStore] = useAuthStore();
    const userAuths = authStore?.authorities || [];
    const isAdmin = userAuths.includes('global:admin:r') || userAuths.includes('global:admin:w');
    const hasAnyAuth = authorities =>
        isAdmin || authorities?.some(auth => userAuths.includes(auth));
    const hrVisible = hasAnyAuth([
        'global:hr-push:r',
        'global:hr-push:w',
        'global:hr-specific-push:r',
        'global:hr-specific-push:w',
        'global:hr-approval:r',
        'global:hr-approval:w',
        'global:hr-template:w',
        'app:hr-push:r',
        'app:hr-push:w',
        'app:hr-specific-push:r',
        'app:hr-specific-push:w',
        'app:hr-approval:r',
        'app:hr-approval:w',
        'app:hr-template:w',
    ]);
    const auditMgr = extAttr?.userAttr?.auditMgr ?? false;

    const menus = MenuConfig.filter(({children}) => _.isEmpty(children));

    MenuConfig.forEach(({children}) => {
        if (children && children.length > 0) {
            menus.push(
                ...children.filter(item => !item.authorities || hasAnyAuth(item.authorities))
            );
        }
    });

    const [selMenuKey, setSelMenuKey] = useState(MenuConfig[0].path);
    const location = useLocation();
    const [{appId}] = useAppStore();

    useEffect(() => {
        // 初始进入或刷新页面时预先判断下需要高亮哪个菜单
        // AdminRouteConfig 需要去掉收尾两个配置项
        menus.forEach(config => {
            // react-router v6：matchPath(pattern, pathname)，end:false 保留 v5 的前缀匹配语义
            const m = matchPath({path: config.path, end: false}, location.pathname);
            if (m && m.pattern.path) {
                setSelMenuKey(m.pattern.path);
            }
        });
    }, [location.pathname, menus]);

    if (appId == null) {
        return null;
    }

    const defaultOpenKeys = MenuConfig.filter(({children}) => children && children.length > 0).map(
        ({path, key}) => path || key
    );

    return (
        <Menu selectedKeys={[selMenuKey]} mode="inline" defaultOpenKeys={defaultOpenKeys}>
            {MenuConfig.map(({label, key, path, icon, isAppMgr, isAuditMgr, isHr, children}) => {
                if (isHr && !hrVisible) {
                    return null;
                }
                if (isAppMgr && !isMgr) {
                    return null;
                }

                if (isAuditMgr && !auditMgr) {
                    return null;
                }

                const hasChildren = !_.isEmpty(children);
                if (hasChildren) {
                    return (
                        <Menu.SubMenu key={key || path} icon={icon} title={label}>
                            {children.map(item => {
                                if (item.isAppMgr && !isMgr) {
                                    return null;
                                }

                                if (item.authorities && !hasAnyAuth(item.authorities)) {
                                    return null;
                                }

                                const to = item.path.replace(':appId', appId);
                                return (
                                    <Menu.Item key={item.path} icon={item.icon}>
                                        <Link to={to}>{item.label}</Link>
                                    </Menu.Item>
                                );
                            })}
                        </Menu.SubMenu>
                    );
                }

                if (!path) {
                    return null;
                }

                const to = path.replace(':appId', appId);

                return (
                    <Menu.Item key={path} icon={icon}>
                        <Link to={to}>{label}</Link>
                    </Menu.Item>
                );
            })}
        </Menu>
    );
}
